import useSWRImmutable from 'swr/immutable';
import { type IPaymentsPageBody, playerPaymentsWithPages } from '@/api/profile';

export const PLAYER_PAYMENTS_PAGE_KEY = 'player/payments/with_pages';

export const isPlayerPaymentsPageKey = (key: unknown) =>
  Array.isArray(key) && key[0] === PLAYER_PAYMENTS_PAGE_KEY;

export const usePlayerPaymentsPage = (body: IPaymentsPageBody) => {
  const { data, error, isLoading } = useSWRImmutable(
    [PLAYER_PAYMENTS_PAGE_KEY, body],
    async () => {
      const page = await playerPaymentsWithPages(body);
      if (!page) throw new Error(PLAYER_PAYMENTS_PAGE_KEY);
      return page;
    }
  );

  return {
    data,
    error,
    isLoading,
  };
};
